
export const ages = [18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99]
export const alturas = [122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241]
export const femEtnia = ['Sin respuesta','Asiatica','Blanca','Latina','Medio Oriente','Mixta','Nativa Americana','Negra','Sudasiática','Otro',]
export const homEtnia = ['Sin respuesta','Asiatico','Blanco','Latino','Medio Oriente','Mixto','Nativo Americano','Negro','Sudasiático','Otro',]
export const femFisic = ['Sin respuesta','Esbelta','Fornida','Grande','Musculosa','Promedio','Tonificada',]
export const homFisic = ['Sin respuesta','Esbelto','Fornido','Grande','Musculoso','Promedio','Tonificado',]
export const femRol = ['Sin respuesta','Activa','Inter Activa','Inter','Inter Pasiva','Pasiva','Sin penetración',]
export const homRol = ['Sin respuesta','Activo','Inter Activo','Inter','Inter Pasivo','Pasivo','Sin penetración',]
export const femSituAmorosa = ['Sin respuesta','Casada','Comprometida','En citas','En pareja','Exclusiva','Relación abierta','Relación seria','Soltera',]
export const homSituAmorosa = ['Sin respuesta','Casado','Comprometido','En citas','En pareja','Exclusivo','Relación abierta','Relación seria','Soltero',]
export const porSioPorNo = ['Si','No']

export const generos = ['Todos', 'Mujer', 'Hombre', 'No Binario']
export const preferencia = ['Todos', 'Mujeres', 'Hombres','No Binarios']
// export const preferencia = ['Mujeres', 'Hombres','No Binarios']
export const estoyBuscando = ['sin respuesta', 'Lo que surja','Una relación','Algo casual','Aún no lo sé', 'Prefiero no decirlo']
export const vihStatus = ['Sin respuesta','Negativo','Positivo','Positivo, no detectable',]

export const impeachment = [
  {
    title:'Odio',
    desc:'Palabras ofensivas, estereotipos racistas o sexistas, deshumanización, incitación al miedo o la discriminación, referencias a discursos de odio, símbolos y logotipos relacionados con discursos de odio',
  },
  {
    title:'Abuso y acoso',
    desc:'Insultos, contenido no deseado de carácter sexual y cosificación explícita, contenido no apto para el ambiente laboral (NSFW) y contenido gráfico no deseado, negación de eventos violentos, acoso dirigido e incitación al acoso',
  },
  {
    title:'Discurso violento',
    desc:'Amenazas violentas, deseo de provocar lesiones, glorificación de la violencia, incitación a la violencia, incitación codificada a la violencia',
  },
  {
    title:'Protección de personas menores de edad',
    desc:'Explotación sexual infantil, ciberacoso a menores (grooming), abuso físico infantil, usuario menor de edad',
  },
  {
    title:'Privacidad',
    desc:'Distribución de información privada, amenazas de distribuir/exponer información privada, distribución no consensuada de imágenes íntimas, distribución de imágenes de mí que no deseo que estén en la plataforma',
  },
  {
    title:'Spam',
    desc:'Llevar a cabo estafas financieras, postear enlaces maliciosos, usar hashtags de forma indebida, falsificar interacciones, enviar respuestas, reposts o Mensajes Directos repetitivos.',
  },
  {
    title:'Suicidio o autolesiones',
    desc:'Fomentar o promover las autolesiones, o bien proporcionar instrucciones o compartir estrategias para autolesionarse.',
  },
  {
    title:'Contenido delicado o perturbador',
    desc:'Graphic Content, Gratutitous Gore, Adult Nudity & Sexual Behavior, Violent Sexual Conduct, Bestiality & Necrophilia, Media depicting a deceased individual',
  },
  {
    title:'Identidades engañosas',
    desc:'Suplantación de identidad, parodias/cuentas de fans que no cumplen las normas',
  },
  {
    title:'Violencia o de incitación al odio',
    desc:'Extremismo violento y terrorismo, grupos y redes de odio.',
  }
]

export const kilitos = [41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272]

export const interactionDescription = ['interacción','visitó tu perfil.','te envio un like','te menciono en un wheel','Te siguio','Te dejo de seguir']
export const interactionIconType = ['interacción','eye','heart', 'at', 'person-add','person-remove']
// export const interactionIconColor = [
//     ['#E1335F', '#DA0037', '#AE002C'],
//     ['#4070ff', '#2864FF', '#4070ff'],
//     ['#E1335F', '#DA0037', '#AE002C'],
//     ['#E1335F', '#DA0037', '#AE002C'],
//     ['#1D1228', '#1D1228'],
//     ['#0F0617', '#1D1228'],
//     ['#1D1228', '#1D1228'],
//     ['#1D1228', '#1D1228'],
//   ]

export const interactionIconColor = [
  ['#E1335F', '#DA0037', '#AE002C'],
  ['#4070ff', '#2864FF', '#4070ff'],
  ['#E1335F', '#DA0037', '#AE002C'],
  ['#E1335F', '#DA0037', '#AE002C'],
  ["#FEB692", "#EA5455"], ["#CE9FFC", "#7367F0"],
  ["#90F7EC", "#32CCBC"], ["#FFF6B7", "#F6416C"], 
  ["#F97794", "#623AA2"], ["#FCCF31", "#F55555"], 
  ["#F761A1", "#8C1BAB"], ["#43CBFF", "#9708CC"],
  ["#FDEB71", "#F8D800"], ["#ABDCFF", "#0396FF"], 
  ["#5EFCE8", "#736EFE"], ["#FAD7A1", "#E96D71"], 
  ["#FFD26F", "#3677FF"], ["#A0FE65", "#FA016D"],
  ["#FFDB01", "#0E197D"], ["#FEC163", "#DE4313"], 
  ["#92FFC0", "#002661"], ["#EEAD92", "#6018DC"],
  ["#F6CEEC", "#D939CD"], ["#52E5E7", "#130CB7"], 
  ["#81FBB8", "#28C76F"], ["#E2B0FF", "#9F44D3"],
  ["#F1CA74", "#A64DB6"], ["#E8D07A", "#5312D6"],
  ["#EECE13", "#B210FF"], ["#79F1A4", "#0E5CAD"], 
  ["#FDD819", "#E80505"], ["#FFF3B0", "#CA26FF"],
  ["#FFF5C3", "#9452A5"], ["#F05F57", "#360940"], 
  ["#2AFADF", "#4C83FF"], ["#FFF886", "#F072B6"],
  ["#97ABFF", "#123597"], ["#F5CBFF", "#C346C2"], 
  ["#FFF720", "#3CD500"], ["#FF6FD8", "#3813C2"],
  ["#EE9AE5", "#5961F9"], ["#FFD3A5", "#FD6585"], 
  ["#C2FFD8", "#465EFB"], ["#FD6585", "#0D25B9"],
  ["#FD6E6A", "#FFC600"], ["#65FDF0", "#1D6FA3"], 
  ["#6B73FF", "#000DFF"], ["#FF7AF5", "#513162"],
  ["#F0FF00", "#58CFFB"], ["#FFE985", "#FA742B"], 
  ["#FFA6B7", "#1E2AD2"], ["#FFAA85", "#B3315F"],
  ["#72EDF2", "#5151E5"], ["#FF9D6C", "#BB4E75"], 
  ["#F6D242", "#FF52E5"], ["#69FF97", "#00E4FF"],
  ["#3B2667", "#BC78EC"], ["#70F570", "#49C628"], 
  ["#3C8CE7", "#00EAFF"], ["#FAB2FF", "#1904E5"],
  ["#81FFEF", "#F067B4"], ["#FFA8A8", "#FCFF00"], 
  ["#FFCF71", "#2376DD"], ["#FF96F9", "#C32BAC"]
]
